<template>
    <v-dialog v-model="dialog" max-width="670" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">{{$t('global.edit')}} {{$t('homework.header')}}{{$t('global.y')}}</h2>

                    <ValidationProvider :name="$t('homework.title')" rules="required|max:80" v-slot="{ errors }">
                        <v-text-field :label="$t('homework.title')"
                                      v-model="homework.title"
                                      class="mt-5"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-title'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('homework.description')" rules="required" v-slot="{ errors }">
                        <ckeditor :editor="editor"
                                  v-model="homework.description"
                                  :config="editorConfig"
                                  class="my-7"
                        ></ckeditor>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('homework.team')" rules="required" v-slot="{ errors }">
                        <v-select :items="TEAMS"
                                  :label="$t('homework.team')"
                                  item-text="name"
                                  item-value="id"
                                  v-model="homework.team_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-team'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('homework.subject')" rules="required" v-slot="{ errors }">
                        <v-select :items="SUBJECTS"
                                  :label="$t('homework.subject')"
                                  item-text="name"
                                  item-value="id"
                                  v-model="homework.course_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-subject'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('homework.lesson')" rules="required" v-slot="{ errors }">
                        <v-select :items="filteredLessons"
                                  :label="$t('homework.lesson')"
                                  item-text="title"
                                  item-value="id"
                                  v-model="homework.lesson_id"
                                  :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-lesson'" size="15" class="mr-1"></svg>
                            </template>

                            <template v-slot:append>
                                <svg v-svg="'icon-select'" size="16"></svg>
                            </template>
                        </v-select>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingSave">{{$t('global.save')}}</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">{{$t('global.close')}}</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    export default {
        props: ['homework_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                loadingSave: false,
                homework: {},
                editor: ClassicEditor,
                editorConfig: {},
            }
        },

        watch: {
            'dialog': function (newVal) {
                if(newVal) {
                    this.loadingRequest = true;
                    this.$api('homework').show(this.homework_id).then((res) => {
                        this.homework = res.data.homework;
                    }).finally(() => {
                        this.loadingRequest = false;
                    })
                }
            }
        },

        computed: {
            ...mapGetters(['TEAMS', 'SUBJECTS', 'LESSONS']),
            filteredLessons() {
                return this.LESSONS.filter(item => item.course_id === this.homework.course_id);
            }
        },

        methods: {
            save() {
                this.loadingSave = true;
                this.$store.dispatch('EDIT_HOMEWORK', this.homework)
                    .then(() => {
                        this.dialog = false;
                        this.homework = {};
                        this.$refs.form.reset();
                        this.$parent.$emit('getData');
                        this.$store.dispatch('alert', {type: 1, message: this.$t('global.success_edited')});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/dialog";
</style>